"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStatusType = void 0;
var GameStatusType;
(function (GameStatusType) {
    GameStatusType["STANDBY"] = "standby";
    GameStatusType["STARTED"] = "started";
    GameStatusType["PAUSED"] = "paused";
    GameStatusType["ENDED"] = "ended";
})(GameStatusType || (exports.GameStatusType = GameStatusType = {}));
//# sourceMappingURL=GameStatus.js.map